var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWarning(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "error"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Triangle",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.6344 2.24736L59.5701 54.1187C60.5738 56.1261 59.7601 58.5672 57.7526 59.571C57.1884 59.8531 56.5661 60 55.9352 60H4.0639C1.81947 60 0 58.1805 0 55.9361C0 55.3052 0.14689 54.683 0.429037 54.1187L26.3647 2.24736C27.3684 0.23988 29.8095 -0.573812 31.817 0.429927C32.6035 0.823165 33.2412 1.46088 33.6344 2.24736Z",
    fill: "#FFF5EA"
  }), /*#__PURE__*/React.createElement("g", {
    id: "icon/tick"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.5 28.5C31.5 27.6716 30.8284 27 30 27C29.1716 27 28.5 27.6716 28.5 28.5V39C28.5 39.8284 29.1716 40.5 30 40.5C30.8284 40.5 31.5 39.8284 31.5 39V28.5ZM31.5 43.5C31.5 42.6716 30.8284 42 30 42C29.1716 42 28.5 42.6716 28.5 43.5C28.5 44.3284 29.1716 45 30 45C30.8284 45 31.5 44.3284 31.5 43.5Z",
    fill: "#FB9D2D"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.4aebff56.svg";
export { ForwardRef as ReactComponent };